import { useContext } from 'react';

import { ItemSetQuestionDetailsContext } from './item-set-question-details-provider';

function useItemSetQuestionDetails() {
  const context = useContext(ItemSetQuestionDetailsContext);

  if (!context) {
    throw new Error(
      'useItemSetQuestionDetails must be used within a ItemSetQuestionDetailsProvider',
    );
  }

  return context;
}

export { useItemSetQuestionDetails };
